import React from 'react'
import ReactMarkdown from 'react-markdown'
import { cn } from '../../../util/classNameConstructor'
const Markdown = ({children, components, className}: {children: React.ReactNode, components?: any, className?: string}) => {
  return (
    <ReactMarkdown className={cn("markdown", className)}
        components={{
        ...components,
        a: ({node, ...props}) => (
        <a {...props} target="_blank" rel="noopener noreferrer">
          {props.children}
        </a>
      )
    }}
    >{children}</ReactMarkdown>
  )
}
export default Markdown